import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ContractsList } from './contract';
import { InviteContracts } from './invite';
import { CheckoutContracts } from './checkout';

export default function CampaignContractsRoutes() {
    return (
        <Routes>
            <Route path=":id" element={<ContractsList />} />
            <Route path=":id/invite" element={<InviteContracts />} />
            <Route path=":id/checkout" element={<CheckoutContracts />} />
            {/*<Route path="/:id/external-search" component={ExternalSearch}/>*/}
        </Routes>
    );
}
